import React, { useState, useEffect } from "react";
import { Button, Table, Spinner } from "react-bootstrap";
import moment from "moment";
import up_down_arrow from "../../../../Assets/svg/up_down_arrow.svg";
import action_icon_1 from "../../../../Assets/svg/tableData/action-icon-1.svg";
import action_icon_2 from "../../../../Assets/svg/tableData/action-icon-2.svg";
import AddUpdateContentPopup from "./addUpdateContentPop";
import { del } from "../../../../helpers/api_helper";
import DeleteConfirmationModal from "../../../../components/DeleteConfirmation";
import toast from "react-hot-toast";
import useCheckPermission from "../../../../hooks/useCheckPermission";

const TableData = ({ faqData, setRefresh }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [selectdFaq, setSelectedFaq] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [faqToDelete, setFaqToDelete] = useState(null);

  const hasUpdatePermission = useCheckPermission("faq", "UPDATE");
  const hasDeletePermission = useCheckPermission("faq", "DELETE");

  useEffect(() => {
    if (faqData && faqData.length > 0) {
      setLoading(false);
    }
  }, [faqData]);

  const handleDelete = async () => {
    try {
      const response = await del(`/faq/${faqToDelete}`);
      if (response.success) {
        setRefresh(true);
        toast.success("FAQ deleted successfully");
      } else {
        console.log(response.message);
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowConfirm(false);
    }
  };

  const confirmDelete = (id) => {
    setFaqToDelete(id);
    setShowConfirm(true);
  };

  const handleEdit = (data) => {
    setSelectedFaq(data);
    setModalMode("edit");
    setShowModal(true);
  };

  return (
    <>
      <AddUpdateContentPopup
        showModal={showModal}
        setShowModal={setShowModal}
        handleRefresh={() => setRefresh(true)}
        mode={modalMode}
        faqData={selectdFaq}
      />

      <DeleteConfirmationModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={handleDelete}
      />

      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100px" }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <Table responsive>
          <thead>
            <tr>
              <th className="fw-normal border-0">Question</th>
              <th className="fw-normal border-0">Answer</th>
              <th className="fw-normal border-0">Status</th>
              <th className="fw-normal border-0">
                <Button className="border-0 p-0" variant="transparent">
                  Time/Date{" "}
                  <span className="icn ms-2">
                    <img src={up_down_arrow} alt="" />
                  </span>
                </Button>
              </th>
              <th className="fw-normal border-0">Action</th>
            </tr>
          </thead>
          <tbody>
            {faqData && faqData.length > 0 ? (
              faqData?.map((data, key) => (
                <tr key={key}>
                  <td>{data?.question ? data?.question : "-"}</td>
                  <td>{data?.answer ? data?.answer : "-"}</td>

                  <td>{data?.status ? data?.status : "-"}</td>

                  <td>
                    {data?.created_at
                      ? moment(data?.created_at).format("DD-MM-YYYY hh:mm A")
                      : "-"}
                  </td>
                  <td>
                    <div className="d-flex align-items-center gap-10">
                      {hasUpdatePermission && <Button
                        onClick={() => handleEdit(data)}
                        className="border-0 p-0"
                        variant="transparent"
                      >
                        <img src={action_icon_1} alt="" />
                      </Button>}
                      {hasDeletePermission && <Button
                        className="border-0 p-0"
                        variant="transparent"
                        onClick={() => confirmDelete(data?._id)}
                      >
                        <img src={action_icon_2} alt="" />
                      </Button>}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No data available</td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default TableData;
